/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, October 20th 2021, 1:05:04 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import { osMUITheme, ThemeProvider } from "theme/styles";

export const OSThemeProvider = ({ children }) => <ThemeProvider theme={osMUITheme}>{children}</ThemeProvider>;
